import { Link as MLink } from '@mui/material'
import Link, { LinkProps } from 'next/link'
import { config } from '@/config'
import { Utils } from '@/lib/utils'

export const TermsOfService = (props: Omit<LinkProps, 'href' | 'as'>) => (
  <Link rel="noopener" target="_blank" href="/terms-of-service" {...props}>
    Terms of Service
  </Link>
)

export const PrivacyPolicy = (props: Omit<LinkProps, 'href' | 'as'>) => (
  <Link rel="noopener" target="_blank" href="/privacy-policy" {...props}>
    Privacy Policy
  </Link>
)

export const LegalInformation = () => {
  const formattedPhone = Utils.formatPhoneToDashed(config.customerSupport.legalPhone)

  return (
    <span>
      Jaxco Industries, DBA Charleston Wrap. • 321 Anderson Road , Walterboro, SC 29488 •{' '}
      <MLink href={`tel:${config.customerSupport.legalPhone}`}>{formattedPhone}</MLink>
    </span>
  )
}
